import React from 'react';
import './KidoFooter.css';
import Logo from './kido-logo.png';

export default function Footer() {
  return (
    <footer className="kido-footer" id="help">
      <div className="kido-footer-main">
        <div className="kido-footer-brand">
          <img src={Logo} style={{ width: '100px', height: 'auto' }} alt="KIDO" />
        </div>
        <p></p>
      </div>
      <div className="kido-footer-contact">
        <span>დაგვიკავშირდი</span>
        <a href="tel:+995599011572">+995 599 01 15 72</a>
        <a href="mailto:shop@kid-o.ge">shop@kid-o.ge</a>
      </div>
      <div className="kido-footer-socials" aria-label="Social media">
        <a href="https://wa.me/995599011572" target="_blank" rel="noreferrer">WhatsApp</a>
        <a href="https://www.facebook.com/share/1H2crMjo6r/?mibextid=wwXIfr" target="_blank" rel="noreferrer">Facebook</a>
        <a href="https://www.instagram.com/kido65674?utm_source=ig_web_button_share_sheet&stkn=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer">Instagram</a>
      </div>
    </footer>
  );
}
